import React, { useEffect, useRef, useState } from 'react'
import './Events.css';
import { pastEvents } from './Data/PastEvents';
import { recentEvents } from './Data/RecentEvents';

function Events() {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const trackRef = useRef(null);
    const carouselContainerRef = useRef(null);

    const [selectedEvent, setSelectedEvent] = useState(null);
    const [visibleCount, setVisibleCount] = useState(6);

    const reversedEvents = [...pastEvents].reverse();
    const visibleEvents = reversedEvents.slice(0, visibleCount);

    useEffect(() => {
        document.title = 'Events – NCC';

        const prev = prevRef.current;
        const next = nextRef.current;
        const track = trackRef.current;
        const carouselContainer = carouselContainerRef.current;

        let cardWidth = track.children[0]?.offsetWidth || 0;
        let carouselWidth = carouselContainer.offsetWidth;

        if (window.innerWidth < 750) {
            next.classList.add('hide');
        }

        const handleResize = () => {
            cardWidth = track.children[0]?.offsetWidth || 0;
            carouselWidth = carouselContainer.offsetWidth;
        };

        window.addEventListener('resize', handleResize);

        let index = 0;

        const handleNext = () => {
            index++;
            prev.classList.add('show');
            track.style.transform = `translateX(-${index * cardWidth}px)`;

            if ((pastEvents.length * cardWidth - (index * cardWidth)) < carouselWidth) {
                next.classList.add('hide');
            }
            if (index + 5 >= visibleCount && visibleCount < pastEvents.length) {
                setVisibleCount(prev => prev + 2);
            }
        };

        const handlePrev = () => {
            index--;
            next.classList.remove('hide');

            if (index === 0) {
                prev.classList.remove('show');
            }

            track.style.transform = `translateX(-${index * cardWidth}px)`;
        };

        next.addEventListener('click', handleNext);
        prev.addEventListener('click', handlePrev);

        return () => {
            next.removeEventListener('click', handleNext);
            prev.removeEventListener('click', handlePrev);
            window.removeEventListener('resize', handleResize);
        };

    }, [pastEvents.length]);

    return (
        <div style={{ marginBottom: '2vw' }}>
            <div className='recent-events'>
                <div class="section-heading text-center d-flex align-items-center justify-content-around py-3">
                    <div class="line"></div>
                    <p class="heading">Recent Events</p>
                    <div class="line"></div>
                </div>

                <div id="recentEventsCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-theme="dark" data-bs-touch="true">
                    <div class="carousel-inner">
                        {recentEvents.map((event, index) => (
                            <div class={`carousel-item ${index === 0 ? 'active' : ''}`} key={event.id}>
                                <img src={event.src} alt={event.alt} class="d-block" onclick="changeCarouselInterval()" />
                                <div className="block">
                                    {event.link ? (
                                        <a href={event.link}>{event.title}</a>
                                    ) : (
                                        event.title
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    <button class="carousel-control-prev" type="button" data-bs-target="#recentEventsCarousel" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon"></span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#recentEventsCarousel" data-bs-slide="next">
                        <span class="carousel-control-next-icon"></span>
                    </button>
                </div>
            </div>

            <div className='past-events'>
                <div class="section-heading text-center d-flex align-items-center justify-content-around py-3">
                    <div class="line"></div>
                    <p class="heading">Past Events</p>
                    <div class="line"></div>
                </div>

                <div class="recom">
                    <div className="carousel-container" ref={carouselContainerRef}>
                        <div class="carousel-inner">
                            <div className="track" ref={trackRef}>
                                {visibleEvents.map((event) => (
                                    <div className="card-container" key={event.id}>
                                        <div className="card">
                                            <div class="img">
                                                <img
                                                    src={event.card.src}
                                                    alt={event.card.alt}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#eventModal"
                                                    onClick={() => setSelectedEvent(event)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div class="nav event-nav">
                            <button className="prev" ref={prevRef}>
                                <i class="fa fa-chevron-left"></i>
                            </button>
                            <button className="next show" ref={nextRef}>
                                <i class="fa fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Modal */}
                <div className="modal fade" id="eventModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '900px' }}>
                        <div className="modal-content">
                            <div className="modal-body p-0">
                                {selectedEvent && (
                                    <div className="container-fluid p-0">
                                        <div className="row d-flex modal-box m-0">
                                            <div className="col-6 px-0 align-self-center img-container">
                                                <img
                                                    src={selectedEvent.modalImage}
                                                    alt={selectedEvent.title}
                                                    style={{ width: '100%' }}
                                                    className="imga"
                                                />
                                            </div>

                                            <div className="col-6 modal-event">
                                                <p className="text-center event-name" style={{ paddingTop: '20px' }}>
                                                    {selectedEvent.title}
                                                </p>

                                                <p
                                                    className="text-center event-des"
                                                    style={{ paddingTop: '10px' }}
                                                    dangerouslySetInnerHTML={{ __html: selectedEvent.description }}
                                                />

                                                {selectedEvent.date && (
                                                    <p className="event-details" style={{ paddingTop: '10px', fontSize: '15px' }}>
                                                        {selectedEvent.date}
                                                    </p>
                                                )}

                                                {selectedEvent.venue && (
                                                    <p className="event-details" style={{ fontSize: '15px' }}>
                                                        {selectedEvent.venue}
                                                    </p>
                                                )}

                                                {selectedEvent.extraInfo && (
                                                    <p className="event-details" style={{ fontSize: '15px' }}>
                                                        {selectedEvent.extraInfo}
                                                    </p>
                                                )}

                                                {selectedEvent.resultLink && (
                                                    <p className="event-details" style={{ fontSize: '16px' }}>
                                                        <a
                                                            href={selectedEvent.resultLink}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{
                                                                color: '#ffd500',
                                                                textDecoration: 'none',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '5px',
                                                                fontSize: '17px',
                                                                fontWeight: '800'
                                                            }}
                                                        >
                                                            View Results
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M7 17L17 7"></path>
                                                                <path d="M7 7H17V17"></path>
                                                            </svg>
                                                        </a>
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Events;